Vue.component("classic-modal",
    {
        template: "#vue-classic-modal",

        computed: {
            ...Vuex.mapGetters(
                {
                    getContractByType: "getPreparedContractByType",
                    trans: "getTranslation"
                }
            ),
            ...Vuex.mapState(
                {
                    pid: state => state.assistant.pid,
                    orderPackages: state => state.assistant.orderPackages
                }
            ),
            sortedOrderPackages()
            {
                return Object.values(this.orderPackages).sort((first, next) =>
                {
                    return first.data.price.priceNet - next.data.price.priceNet;
                });
            }
        },

        data()
        {
            return {
                modalSelector: "#classicModal"
            };
        },

        ready()
        {
            this.$root.$on("openClassicModal", () =>
            {
                this.onOpenModal();

            });
        },

        methods: {
            ...Vuex.mapMutations(
                [
                    "setAssistantModuleValue"
                ]
            ),
            ...Vuex.mapActions(
                [
                    "fetchClassicOrderPackages"
                ]
            ),
            onOpenModal()
            {
                $(this.modalSelector).modal("show");
                this.fetchClassicOrderPackages();
            },
            orderPackageAmount(data)
            {
                let amount = null;

                data.properties.forEach(property =>
                {
                    if (property.property.names.name === "InclusiveOrders")
                    {
                        amount = property.valueInt;
                    }
                });

                return amount.toLocaleString(window.App.language || "de");
            },
            orderPackageDuration(data)
            {
                let duration = null;

                data.properties.forEach(property =>
                {
                    if (property.property.names.name === "Interval")
                    {
                        duration = property.selection.name;
                    }
                });

                return duration;
            }
        }
    });

